import React from 'react'
import Fragment from '../common/fragment'


function FragmentDN(props) {
  return (
    <Fragment pos="nnnn" {...props}>
      <p>
      El coro de niños toca flautas de plástico. La música acompaña a los trenes. El
Muñeco escuchará sus cantos. Las abejas. La voz de Dios en la plaza: el aire de los
niños. Flautas y espejos. Dioses y melodías. Usted no escuchará nada, porque esto
es de otro mundo.
      </p>
    </Fragment>
  )
}


export default FragmentDN
